export enum CaseSubjectTypeFilterOptions {
    None = 1,
    Deleted= 2
}
